<div class="flex flex-column field m-0">
  <!-- No label: render nothing, otherwise the empty label + 6px gap pushes the input down -->
  @if (label() || tooltip()) {
    <div class="flex flex-column gap-1">
      <div class="flex gap-1">
        <label [for]="labelFor()"
               [class]="styleClass() || 'text-sm-medium text-gray-700'">
          {{ label() }}
          @if (isRequired()) {
            <span >*</span>
          }
        </label>
        @if (showIsOptional()) {
          <div class="text-sm-medium text-gray-400">(optional)</div>
        }
      </div>
      @if (tooltip() && tooltip().length > 0) {
        <div class="text-sm-regular text-gray-600">{{ tooltip() }}</div>
      }
    </div>
  }
  <ng-content></ng-content>
</div>
